import { EventCategory } from "./attributes/EventCategorySet";
import { EventLocation } from "./attributes/EventLocationSet";
import { EventStatus } from "./attributes/EventStatusSet";

import { FilterType } from "@/schemas/screen/filters/FilterCriteria";
import { type FilterBySelection } from "@/schemas/screen/filters/FilterBySelection";

export type EventFilterCriteria = {
  type: FilterType.EVENT;
  category: FilterBySelection<EventCategory> | null;
  status: FilterBySelection<EventStatus> | null;
  location: FilterBySelection<EventLocation> | null;
  exclude: string[] | null;
};

export const InitialEventFilterCriteria: EventFilterCriteria = {
  type: FilterType.EVENT,
  category: null,
  status: null,
  location: null,
  exclude: null,
};
